import { useQuery } from "@tanstack/react-query";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

export const useFetchCompanies = () => {
	return useQuery({
		queryKey: [CompanyQueryKeys.companies], 
		queryFn: () => SATOSPortal.GetCompanies(),
	});
};

export class CompanyQueryKeys {
	static readonly companies = "companies";
}
